import React from "react";
import { Mail, Instagram } from "lucide-react";

export default function Contact({ isFullscreen, handleFormSubmit }) {
    if (isFullscreen) return null;

    return (
        <section
            id="contact"
            className="h-full flex flex-col justify-between"
        >
            {/* Main Content */}
            <div className="flex flex-col justify-center py-10 sm:py-16 flex-grow">
                <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 w-full">

                    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">

                        {/* LEFT — About */}
                        <div className="text-center lg:text-left">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight">
                                Let's work together
                            </h2>

                            <p className="mt-3 text-neutral-600 dark:text-neutral-400 leading-relaxed text-sm sm:text-base">
                                I’m Aakarsh Yohaan, a photographer focused on cinematic storytelling
                                and rich color tones. I work on travel, portrait, and commercial projects.
                            </p>

                            <div className="mt-6 flex justify-center lg:justify-start gap-6 text-neutral-600 dark:text-neutral-400 text-sm">
                                <a
                                    href="mailto:hello@zeusyohaan.com"
                                    className="inline-flex items-center gap-2 hover:opacity-80 transition"
                                >
                                    <Mail className="w-4 h-4" />
                                    hello@zeusyohaan.com
                                </a>

                                <a
                                    href="https://instagram.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="inline-flex items-center gap-2 hover:opacity-80 transition"
                                >
                                    <Instagram className="w-4 h-4" />
                                    @zeusyohaan
                                </a>
                            </div>
                        </div>

                        {/* RIGHT — Contact Form */}
                        <div className="grid gap-3">
                            <input
                                type="text"
                                name="name"
                                placeholder="Your name"
                                className="w-full rounded-2xl border border-neutral-300/70 dark:border-neutral-700 bg-white dark:bg-neutral-900 px-4 py-3 text-sm"
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Your email"
                                className="w-full rounded-2xl border border-neutral-300/70 dark:border-neutral-700 bg-white dark:bg-neutral-900 px-4 py-3 text-sm"
                            />

                            <textarea
                                name="message"
                                placeholder="Tell me about your project…"
                                className="w-full h-28 rounded-2xl border border-neutral-300/70 dark:border-neutral-700 bg-white dark:bg-neutral-900 px-4 py-3 resize-none text-sm"
                            />

                            <button
                                onClick={handleFormSubmit}
                                className="justify-self-start rounded-2xl px-6 py-3 text-sm font-medium bg-neutral-900 text-white dark:bg-white dark:text-neutral-900 hover:opacity-90 transition"
                            >
                                Send Message
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            {/* Bottom Copyright */}
            <div className="border-t border-neutral-200 dark:border-neutral-800 py-4 text-center text-xs text-neutral-500 dark:text-neutral-400">
                © {new Date().getFullYear()} ZeusYohaan — Photography
            </div>
        </section>
    );
}